import type { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { isDevEnv } from '@/config/utils';

export function logResponseErrorInterceptor(e: AxiosError) {
  if (!isDevEnv()) return;


}

export function logRequestInterceptor(config: InternalAxiosRequestConfig) {
  if (!isDevEnv()) return config;



  return config;
}